import { ajax } from '../../utils/ajax-handler';
import defaultErrorMessages from '../../utils/default-error-message';

export default class {
    onMount() {
        this.subscribeTo(document).on('presenceEdit', this.editReducer.bind(this));
    }
    findTabWithModule(regions, module) {
        let tab;
        for (const [rKey, region] of Object.entries(regions)) {
            for (const [, layout] of Object.entries(region.layouts)) {
                if (!!layout.positions.find(p => p.moduleLocator === module)) {
                    tab = rKey.toLowerCase();
                    break;
                }
            }
        }
        return tab;
    }
    editReducer(event) {
        const { action: { name }, payload } = event.detail;
        switch (name) {
            case 'EDIT_EBAY_USER_PROFILE':
                this.emit('set', {
                    key: 'editing',
                    value: true
                });
                const tab = this.findTabWithModule(this.input.regions, 'ABOUT_DESCRIPTION_EDIT_MODULE');
                if (tab) {
                    window.location.hash = tab === 'tab0' ? '' : `#${tab}`;
                }
                break;
            case 'SAVE_EBAY_USER_PROFILE':
                this.emit('set', {
                    key: 'saveError',
                    value: null
                });
                this.emit('set', {
                    key: 'saving',
                    value: true
                });
                this.saveProfile()
                    .then(() => {
                        this.emit('set', {
                            key: 'editing',
                            value: false
                        });
                    })
                    .catch((response) => {
                        this.emit('set', {
                            key: 'saveError',
                            value: response
                        });
                    })
                    .then(() => {
                        this.emit('set', {
                            key: 'saving',
                            value: false
                        });
                    });
                break;
            case 'UPDATE_PROFILE_FIELD':
                this.emit('set', {
                    key: 'payload',
                    partial: true,
                    value: {
                        [payload.field]: payload.value
                    }
                });
                this.emit('set', {
                    key: 'saveError',
                    value: null
                });
                break;
            case 'SET_SAVE_EDIT_ERROR':
                this.emit('set', {
                    key: 'saveError',
                    value: payload
                });
                break;
            default:
                console.warn('Unexpected action name for profile edit', event.detail);
        }
    }
    async saveProfile() {
        return new Promise((resolve, reject) => {
            const link = document.createElement('a');
            link.href = window.location.href;
            const request = {
                url: link.pathname,
                method: 'POST',
                body: Object.assign(
                    { userLogoUrl: '', aboutDescription: '' },
                    this.input.globalState.profileEdit.payload
                ),
                headers: {
                    'x-ebay-c-enduserctx': this.input.endUserContext
                }
            };
            ajax(request, {
                successCallBack: () => {
                    resolve();
                },
                errorCallBack: (response) => {
                    if (response.modules) {
                        reject(response);
                    } else {
                        reject({
                            modules: {
                                STATUS_MESSAGE_INLINE_MODULE: defaultErrorMessages['en-US']
                            }
                        });
                    }
                }
            },
            10000);
        });
    }
}
